<template>
    <div class="card my-1">
        <div class="card-header text-white text-center app-class-summary-panel-headings">
            <h4><strong>LABORATORY</strong></h4>
        </div>
        <div class="card-body app-class-summary-panel-body">
            <v-simple-table>
                <template v-slot:default>
                    <tbody>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                Medical Laboratory technician available
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_1" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                Laboratory is open every day of the week
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_2" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                Microscope available and functional
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_3" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                Malaria rapid tests available
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_4" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                        <tr>
                            <td class="app-class-summary-panel-text-bold text-left">
                                Centrifuge available and functional
                            </td>
                            <td class="app-class-text-light text-right">
                                <ComponentColorCoderBool 
                                v-bind:prop_qst_model="data_qst_5" 
                                v-bind:prop_qst_show_bools_as_sym="true"/>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </div>
    </div>
</template>

<script>
//########################################
//IMPORTS libs
//########################################

//GENERIC COMPONENTS
import ComponentColorCoderBool from '@/components/ComponentColorCoderBool';

//########################################
//IMPORTS components
//########################################

//########################################
//MAIN
//########################################
export default {
    name: 'ComponentSummary7',

    props:[
        'prop_submission'
    ],

    components:{
        //GENERIC COMPONENTS
        ComponentColorCoderBool
    },

    data: function()
    {
        return {
        }
    },

    computed:{
        data_qst_1:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["Laboratory8/MedLabTechA"];
        },
        data_qst_2:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["Laboratory8/LabOpen7Day"];
        },
        data_qst_3:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["Laboratory8/MicrosAva01"];
        },
        data_qst_4:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["Laboratory8/MalariaTest"];
        },
        data_qst_5:function()
        {
            return this.prop_submission == undefined || this.prop_submission.length == 0 ? undefined : this.prop_submission[0].qsts_all["Laboratory8/CentriAvail"];
        }
    }
}

//call all with signature func_imp.call(this,param_1,param_2)
//############################################
//HELPERS
//############################################

//############################################
//API_REQUESTS
//############################################

//############################################
//DATA_OPPS
//############################################

//############################################
//ACTIONS
//############################################
</script>
